var map = {
	"./DefaultLogoGov.png": [
		869,
		869
	],
	"./DefaultLogoInstitutes.png": [
		568,
		568
	],
	"./DefaultLogoLocalAuthority.png": [
		1864,
		1864
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9895;
module.exports = webpackAsyncContext;